import {
  Directive,
  Input,
  OnInit,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentFactory,
  ComponentRef,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { BadgeWithIconComponent } from '../components/badge-with-icon/badge-with-icon.component';
import { CommitIDsComponent } from '../components/commit-ids/commit-ids.component';

@Directive({
  selector: '[appDynamicComponent]',
})
export class DynamicComponentDirective implements OnInit, OnDestroy {
  @Input() componentName: string;
  @Input() componentInputs: { [key: string]: any };
  @Output() componentOutput = new EventEmitter<any>();

  private componentRef: ComponentRef<any>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ) {}

  ngOnInit(): void {
    this.loadComponent();
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  loadComponent() {
    const componentMappings = {
      BadgeWithIconComponent: BadgeWithIconComponent,
      CommitIDsComponent: CommitIDsComponent,
      // Add other components here
    };

    const component = componentMappings[this.componentName];

    if (!component) {
      return;
    }

    const factory: ComponentFactory<any> =
      this.resolver.resolveComponentFactory(component);
    this.componentRef = this.viewContainerRef.createComponent(factory);

    if (this.componentInputs) {
      for (const [key, value] of Object.entries(this.componentInputs)) {
        this.componentRef.instance[key] = value;
      }
    }

    this.subscribeToOutputs();
  }

  private subscribeToOutputs() {
    if (this.componentRef && this.componentRef.instance) {
      const outputs = Object.keys(this.componentRef.instance)
        .filter(
          (key) => this.componentRef.instance[key] instanceof EventEmitter,
        )
        .map((key) => ({
          name: key,
          emitter: this.componentRef.instance[key] as EventEmitter<any>,
        }));

      outputs.forEach((output) => {
        output.emitter.subscribe((event) => {
          this.componentOutput.emit({ name: output.name, value: event });
        });
      });
    }
  }
}
